module.exports = __webpack_public_path__ + "static/media/MenuCenter.86c083b2.png";